import { Dexie } from 'dexie';

export const db = new Dexie('SE-Database');
db.version(3).stores({
    versaoMinutaVoto: '++idVersaoMinuta, docId, extensao, ultimaAlteracao, etag, conteudo, semAlteracaoConteudo',
    versaoMinutaVotoControleAcesso: '++idControleAcesso, docId, extensao, ultimoAcesso',
    fotoMagistrado: 'idMagistrado, imgBase64, imgContentType',
    stores: 'storeNome, conteudo'
});

export class VersaoMinutaVoto {
    constructor(idVersaoMinuta, docId, extensao, ultimaAlteracao, etag, conteudo, semAlteracaoConteudo) {
        if (idVersaoMinuta) {
            this.idVersaoMinuta = idVersaoMinuta;
        }

        this.docId = docId;
        this.extensao = extensao;
        this.ultimaAlteracao = ultimaAlteracao;
        this.etag = etag;
        this.conteudo = conteudo;
        this.semAlteracaoConteudo = semAlteracaoConteudo;
    }
}

export class VersaoMinutaVotoControleAcesso {
    constructor(idControleAcesso, docId, extensao, ultimoAcesso) {
        if (idControleAcesso) {
            this.idControleAcesso = idControleAcesso;
        }

        this.idControleAcesso = idControleAcesso;
        this.docId = docId;
        this.extensao = extensao;
        this.ultimoAcesso = ultimoAcesso;
    }
}

export class FotoMagistrado {
    constructor(idMagistrado, imgBase64, imgContentType) {
        this.idMagistrado = idMagistrado;
        this.imgBase64 = imgBase64;
        this.imgContentType = imgContentType;
    }
}
